import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';
import { replaceSpaces } from '../Utils';

export default class ItemSubMenu extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, itemCount, downListener, listenerScope) {
    super(scene);

    this.maxItems = itemCount;

    this.verticalMargin = 46;
    this.cornerSize = 20;
    this.currentCategoryName = null;
    this.currentSelectedIndex = -1;

    this.isActive = false;

    this.workingWidth = 178;
    this.workingHeight = 146 * 5;// menubutton height * count

    this.xCollapsed = -this.workingWidth;
    this.xExtended = 0;
    this.bg = this.scene.add.graphics({ fillStyle: { color: 0xff00ff } });
    this.bg.fillRoundedRect(0,0,this.workingWidth, this.workingHeight, this.cornerSize);
    this.add(this.bg);

    /** @type {Phaser.GameObjects.Image[]} */
    this.items = [];
    for (let i = 0; i < this.maxItems; i++) {
      const item = ABCyaPhaser.Images.addImage(0,0,UIAssetKeys._ICON_MenuContainer_1, this).setOrigin(0)
        .setInteractive();
      item.visible = false;

      item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => {downListener.call(listenerScope, item);});
      this.items.push(item);
    }
  }

  setMenu (itemlist) {
    this.itemData = itemlist;
    this.bg.clear().fillStyle(Phaser.Display.Color.HexStringToColor(this.itemData.tabColor).color)
      .fillRoundedRect(0,0,this.workingWidth, this.workingHeight);
    this.currentCategoryName = replaceSpaces(this.itemData.category, '_');
    const menuCount = this.itemData.count;
    let totalHeight = 0;
    let maxWidth = 0;
    for (let i = 0; i < this.maxItems; i++) {
      const item = this.items[i];
      if (i < menuCount) {
        item.categoryItemIndex = i + 1;
        item.setFrame(`ICON_Menu${this.currentCategoryName}+${i + 1}`).setOrigin(0.5);
        item.ogWidth = item.width;
        item.ogHeight = item.height;
        totalHeight += item.height;
        maxWidth = Math.max(maxWidth, item.width);
        item.visible = true;
      }
      else {
        item.visible = false;
      }
    }
    this.itemsHeight = totalHeight;
    this.itemsWidth = maxWidth;
    this.layoutCurrentMenu();
  }

  layoutCurrentMenu () {
    const len = this.itemData.count;
    const x = this.workingWidth / 2 + this.cornerSize / 2;

    let actualHeight = (this.workingHeight - this.verticalMargin) - this.itemsHeight;
    actualHeight = Math.abs(actualHeight);
    const padding = actualHeight / len;
    let y = this.verticalMargin;
    for (let i = 0; i < len; i++) {
      this.items[i].x = x;
      this.items[i].y = y + this.items[i].height / 2;
      y += this.items[i].height;
      y += padding;
    }
  }

  setTweenPositions (extendedY) {
    this.xExtended = extendedY - this.cornerSize;// 20 is rounded corner on left
  }

  selectMenuItem (value) {
    if (this.currentSelectedIndex >= 0) {
      this.deselectMenuItem(this.currentSelectedIndex);
    }
    this.currentSelectedIndex = value;
    const item = this.items[value];
    item.setFrame(`ICON_Menu${this.currentCategoryName}+${this.currentSelectedIndex + 1}HIGHLIGHT`).setOrigin(0.5);
  }

  deselectMenuItem (value) {
    this.items[value].setFrame(`ICON_Menu${this.currentCategoryName}+${value + 1}`).setOrigin(0.5);
  }

  collapseMenu () {
    this.currentSelectedIndex = -1;
    this.isActive = false;
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, 1000, { x: this.xCollapsed }, Phaser.Math.Easing.Bounce.Out);
  }

  extendMenu (time) {
    this.isActive = true;
    this.scene.tweens.killTweensOf(this);
    ABCyaPhaser.Tweens.addTween(this, time ?? 1000, { x: this.xExtended }, Phaser.Math.Easing.Bounce.Out);
  }
}